import React, {useEffect} from 'react'

import {ThemeProvider} from 'styled-components'

import {theme} from '@miro-site/design-tokens'
import {GlobalStyle} from '@miro-site/core'
import {TemplateOpenerProvider} from '@miro-site/core'
import {ServicesProvider} from '@miro-site/services'
import {LocalizationProvider} from '@miro-site/localization'

import {initializeCloudwatch} from '../src/system/cloudwatch'

initializeCloudwatch()

const LPBuilderPages = ({Component, pageProps}) => {
  useEffect(() => {
    handleLegacyInit()
  }, [])

  const handleLegacyInit = async () => {
    const initLegacy = (await import('@miro-site/components-twig')).initLegacy
    initLegacy()
  }

  const pageLocale = pageProps.page?.sys?.locale || 'en'

  return (
    <ServicesProvider withSplitIo withAnalytics>
      <TemplateOpenerProvider>
        <ThemeProvider
          theme={{
            ...theme,
            multipliers: {
              ...theme.multipliers,
              large: value => `${value}px`,
            },
          }}
        >
          <LocalizationProvider
            detectLocale={false}
            detectTranslations={false}
            data={{
              currentLocale: pageLocale,
              translations: pageProps.translations?.map(t => ({
                locale: t.locale,
                url: t.url ? `/${t.url}/` : '/',
              })),
            }}
          >
            <GlobalStyle />
            <Component {...pageProps} />
          </LocalizationProvider>
        </ThemeProvider>
      </TemplateOpenerProvider>
    </ServicesProvider>
  )
}

export default LPBuilderPages
